import { Text, Title } from '@gjensidige/builders-components';

import './TravelHeader.scss';

interface TravelHeaderProps {
  caption?: string;
  headerTitle: string;
  description?: string;
}

export const TravelHeader = ({
  caption = 'report claim',
  headerTitle,
  description,
}: TravelHeaderProps) => {
  return (
    <>
      <Title as="h1" size="6" uppercase={true} className="caption">
        {caption}
      </Title>
      <Title as="h2" size="3" className="title">
        {headerTitle}
      </Title>
      <Text className="description">{description}</Text>
    </>
  );
};
